// extracted by mini-css-extract-plugin
module.exports = {"team-img":"TeamCards_team-img__5GMDy"};